import React from "react";
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { ChevronDown, Lightbulb, AlertTriangle, XCircle } from "lucide-react";

export const StepList = ({ steps }) => (
  <Box sx={{ my: 2, pl: 0.5 }}>
    {steps.map((step, i) => (
      <Box key={i} sx={{ display: "flex", gap: 1.5, mb: 1.5, alignItems: "flex-start" }}>
        <Box sx={{ width: 22, height: 22, borderRadius: "50%", bgcolor: "rgba(56,189,248,0.15)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, mt: 0.2, color: "#38bdf8", fontSize: "0.65rem", fontWeight: 800 }}>{i + 1}</Box>
        <Typography sx={{ fontSize: "0.85rem", color: "#cbd5e1", lineHeight: 1.6 }}>{step}</Typography>
      </Box>
    ))}
  </Box>
);

export const ConfigTable = ({ rows }) => (
  <Box sx={{ my: 2, borderRadius: 2, overflow: "hidden", border: "1px solid rgba(255,255,255,0.06)" }}>
    {rows.map((row, i) => (
      <Box key={i} sx={{ display: "flex", borderBottom: i < rows.length - 1 ? "1px solid rgba(255,255,255,0.06)" : "none" }}>
        <Box sx={{ flex: 1, px: 2, py: 1.2, bgcolor: "rgba(255,255,255,0.03)", fontWeight: 600, fontSize: "0.8rem", color: "#e2e8f0" }}>{row.setting}</Box>
        <Box sx={{ flex: 2, px: 2, py: 1.2, fontSize: "0.8rem", color: "#94a3b8" }}>{row.desc}</Box>
      </Box>
    ))}
  </Box>
);

export const TipBox = ({ type, text }) => {
  const colors = {
    tip: { icon: Lightbulb, bg: "rgba(56,189,248,0.08)", border: "rgba(56,189,248,0.2)", color: "#38bdf8", textColor: "#cbd5e1" },
    warn: { icon: AlertTriangle, bg: "rgba(245,158,11,0.08)", border: "rgba(245,158,11,0.2)", color: "#f59e0b", textColor: "#fde68a" },
    error: { icon: XCircle, bg: "rgba(239,68,68,0.08)", border: "rgba(239,68,68,0.2)", color: "#ef4444", textColor: "#fca5a5" },
  };
  const c = colors[type] || colors.tip;
  const Icon = c.icon;
  return (
    <Box sx={{ my: 2, p: 2, borderRadius: 2, bgcolor: c.bg, border: `1px solid ${c.border}`, display: "flex", gap: 1.5, alignItems: "flex-start" }}>
      <Icon size={18} style={{ flexShrink: 0, marginTop: 2, color: c.color }} />
      <Typography sx={{ fontSize: "0.8rem", color: c.textColor, lineHeight: 1.6 }}>{text}</Typography>
    </Box>
  );
};

export const ArticleAccordion = ({ title, children, defaultExpanded }) => (
  <Accordion defaultExpanded={defaultExpanded} sx={{ bgcolor: "rgba(255,255,255,0.03)", borderRadius: "12px !important", "&:before": { display: "none" }, mb: 1.5, border: "1px solid rgba(255,255,255,0.06)", "&.Mui-expanded": { borderColor: "rgba(56,189,248,0.2)" }, "& .MuiAccordionSummary-root": { borderRadius: "12px", "&.Mui-expanded": { borderBottom: "1px solid rgba(255,255,255,0.06)" } } }}>
    <AccordionSummary expandIcon={<ChevronDown size={18} color="#94a3b8" />} sx={{ px: 2, py: 0.5, "& .MuiAccordionSummary-content": { my: 1.2 } }}>
      <Typography sx={{ fontWeight: 600, fontSize: "0.9rem", color: "#e2e8f0" }}>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails sx={{ px: 2, pb: 2, pt: 0.5 }}>{children}</AccordionDetails>
  </Accordion>
);
